import React from 'react'
import { Tooltip } from '@fluentui/react-components'

type ConditionalTooltipProps = {
   show: boolean
   content: string
   children: React.ReactElement | ((props: any) => React.ReactElement)
}

export const ConditionalTooltip = ({ show, content, children }: ConditionalTooltipProps) => {
   return show ? (
      <Tooltip relationship="description" positioning={'above-end'} withArrow showDelay={300} hideDelay={100} content={content}>
         {children}
      </Tooltip>
   ) : (
      <>{children}</>
   )
}
